import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '@aiwyn/auth';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnDestroy {
  private readonly _unsubscribe$ = new Subject<void>();

  constructor(
    public authService: AuthService
  ) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  /**
   * Google Identity Platform handles logging the user in, we just need to handle when
   * the user clicks the "Create an account" link.
   */
  createAccount(): void {
    this.authService.navigateToRegistration().pipe(
      take(1)
    ).subscribe();
  }
}
